import Content from "../Components/Dashbord/Content";
import Header from "../Components/Dashbord/Header";
import  { TasksContextProvider } from "../context/tasks-content";

const Dashboard= () =>{
   
 return (
  <>
  <Header/>
    <Content/>
  </>
   
 );
};
export default Dashboard;